import { render, staticRenderFns } from "./monitorProductSettings.vue?vue&type=template&id=388282f2&scoped=true&"
import script from "./monitorProductSettings.vue?vue&type=script&lang=js&"
export * from "./monitorProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./monitorProductSettings.vue?vue&type=style&index=0&id=388282f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388282f2",
  null
  
)

export default component.exports